module.exports = __webpack_public_path__ + "static/mbrtsimg-dc701114fab7d4ac21e9c9b2d7fb5887.jpg";